import React, { useEffect, useState } from "react"
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js"
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Input,
  Row,
  Col,
  Tooltip,
  Spinner,
} from "reactstrap"
import toast from "react-hot-toast"

const StripeForm = ({
  paymentOption,
  setPaymentOption,
  payment_intent,
  clientSecret,
  handleCreateIntent,
  setTransactionID,
  transactionID,
  setLoadingPayment,
  submitLoading,
  setSubmitLoading,
  handleComplete,
  extraCharges,
  apiTag,
  formData
}) => {
  const stripe = useStripe()
  const elements = useElements()
  const [postalCode, setPostalCode] = useState("")

  const cardElementOptions = {
    style: {
      base: {
        fontSize: "16px",
        color: "#495057",
        "::placeholder": {
          color: "#6c757d",
        },
        backgroundColor: "#fff",
        padding: "12px",
        borderRadius: "5px",
      },
      invalid: {
        color: "#dc3545",
      },
    },
    hidePostalCode: true,
  }

  const handlePaymentOptionChange = e => {
    const selectedOption = e.target.value
    setPaymentOption(selectedOption)

    if (selectedOption === "stripe-moto") {
      handleCreateIntent()
    } else if (selectedOption === "stripe-dashboard") {
      setTransactionID("")
    }
  }

  const handleSubmit = async () => {
    if (postalCode == "" && paymentOption === "stripe-moto") {
      setSubmitLoading(false)
      toast.error("please enter a postal code", { duration: 3000 })
      return
    } else {
      if (paymentOption === "stripe-moto") {
        if (!stripe || !elements) {
          setLoadingPayment(false)
          setSubmitLoading(false)
          return
        }
        setLoadingPayment(true)

        const cardElement = elements.getElement(CardElement)
        const { error: stripeError, paymentIntent } =
          await stripe.confirmCardPayment(clientSecret, {
            payment_method: {
              card: cardElement,
              billing_details: {
                name: `${formData?.firstName} ${formData?.lastName}`,
                address: {
                  postal_code: postalCode, 
                },
              },
            },
          })

        if (stripeError) {
          alert(
            "Payment failed. Please try again. Error: " + stripeError.message
          )
          setLoadingPayment(false)
          setSubmitLoading(false)
          return
        }
        if (paymentIntent.status === "succeeded") {
          handleComplete(payment_intent)
        }
      }
      if (paymentOption === "stripe-dashboard") {
        handleComplete(transactionID)
      }
    }
  }

  useEffect(() => {
    if (submitLoading) {
      handleSubmit()
    }
  }, [submitLoading])

  return (
    <div>
      {apiTag == "fhr" ? (
              <>
              {" "}
              <Col>
                <FormGroup>
                  <label for="paymentOption">Payment Option:</label>
                  <Input
                    className="border-secondary"
                    type="select"
                    name="paymentOption"
                    id="paymentOption"
                    value={paymentOption}
                    onChange={handlePaymentOptionChange}
                  >
                    <option value="">Select Payment</option>
                    {extraCharges != 0 && (
                      <option value="stripe-moto">Stripe Moto</option>
                    )}
                
                  </Input>
                </FormGroup>
              </Col>
              {paymentOption === "stripe-moto" && payment_intent && clientSecret ? (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <h5>Stripe Form</h5>
                  <div className="my-2 border border-secondary rounded bg-light">
                    <CardElement
                      options={cardElementOptions}
                      className="form-control"
                    />
                  </div>
                  <Input
                    type="text"
                    placeholder="Enter Postal Code"
                    value={postalCode}
                    onChange={e => setPostalCode(e.target.value)}
                    required
                    className="border-secondary my-3"
                  />
                </div>
              ) : null}
              {paymentOption === "stripe-dashboard" ||
              paymentOption === "paypal" ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginBottom: "20px",
                  }}
                >
                  <Input
                    type="text"
                    id="transactionID"
                    name="transactionID"
                    placeholder="Transaction ID"
                    value={transactionID}
                    onChange={e => setTransactionID(e.target.value)}
                    required
                    className="border-secondary"
                  />
                </div>
              ) : null}
            </>
      ) : (
        <>
          {" "}
          <Col>
            <FormGroup>
              <label for="paymentOption">Payment Option:</label>
              <Input
                className="border-secondary"
                type="select"
                name="paymentOption"
                id="paymentOption"
                value={paymentOption}
                onChange={handlePaymentOptionChange}
              >
                <option value="">Select Payment</option>
                {extraCharges != 0 && (
                  <option value="stripe-moto">Stripe Moto</option>
                )}
                <option value="stripe-dashboard">Stripe Dashboard</option>
                {apiTag !== "fhr" && apiTag !== "a2z" &&  extraCharges != 0 && <option value="worldpay">WorldPay</option>}

              </Input>
            </FormGroup>
          </Col>
          {paymentOption === "stripe-moto" && payment_intent && clientSecret ? (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <h5>Stripe Form</h5>
              <div className="my-2 border border-secondary rounded bg-light">
                <CardElement
                  options={cardElementOptions}
                  className="form-control"
                />
              </div>
              <Input
                type="text"
                placeholder="Enter Postal Code"
                value={postalCode}
                onChange={e => setPostalCode(e.target.value)}
                required
                className="border-secondary my-3"
              />
            </div>
          ) : null}
          {paymentOption === "stripe-dashboard" ||
          paymentOption === "paypal" ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: "20px",
              }}
            >
              <Input
                type="text"
                id="transactionID"
                name="transactionID"
                placeholder="Transaction ID"
                value={transactionID}
                onChange={e => setTransactionID(e.target.value)}
                required
                className="border-secondary"
              />
            </div>
          ) : null}
        </>
      )}
    </div>
  )
}

export default StripeForm
